import { type Enum } from '@webapp/infrastructure/types/Enum'

export const POBillToContactModes = {
  PURCHASER: 0,
  REQUESTER: 1,
  SPECIFIC_USER: 2,
  ACCOUNTS_PAYABLE: 3,
} as const

export type POBillToContactModeEnum = Enum<typeof POBillToContactModes>
